import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    labelLinkCopied: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast message shown when Share link is copied to clipboard */
            labelLinkCopied: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyShareLink.labelLinkCopied?c=3c97u98any87v", defaultMessage: "Link copied to clipboard" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
